import { IOfferCard } from '../../../../types';

export const prepareBookButton = ({ externalOfferUrl, canBeBooked }: IOfferCard) => ({
  link: externalOfferUrl,
  title: canBeBooked ? 'Забронировать' : 'Проверить места',
});
